export const winners = [
    {
        name: "Srinivas Reddy",
        amount: 48640
    },
    {
        name: "Raghavendra Gowda",
        amount: 52980
    },
    {
        name: "Karthik Iyer",
        amount: 61750
    },
    {
        name: "Anjali Menon",
        amount: 35890
    },
    {
        name: "Suresh Naidu",
        amount: 70420
    },
    {
        name: "Lakshmi Narayanan",
        amount: 44260
    },
    {
        name: "Bhavya Shetty",
        amount: 59310
    },
    {
        name: "Praveen Kumar",
        amount: 38170
    },
];


export const GameAndRates = [
    {
        name: "Single Digit",
        rate: "9.5"
    },{
        name: "Jodi Digits",
        rate: "95"
    },{
        name: "Red Brackets",
        rate: "95"
    },{
        name: "Single Pana",
        rate: "150"
    },{
        name: "Double Pana",
        rate: "300"
    },{
        name: "Triple Pana",
        rate: "900"
    },
];


export const marketData = [
    { name: "SUPREME NIGHT", market_open_time: "10:00:00", open_bid_last_time: "20:40:00", close_bid_last_time: "22:40:00" },
    { name: "KARNATAKA NIGHT", market_open_time: "09:00:00", open_bid_last_time: "18:35:00", close_bid_last_time: "19:35:00" },
    { name: "SURYA MORNING", market_open_time: "08:00:00", open_bid_last_time: "09:00:00", close_bid_last_time: "10:00:00" },
];